import { render } from "./IveStatsWidget.vue?vue&type=template&id=d673788c&scoped=true&ts=true"
import script from "./IveStatsWidget.vue?vue&type=script&lang=ts"
export * from "./IveStatsWidget.vue?vue&type=script&lang=ts"

import "./IveStatsWidget.vue?vue&type=style&index=0&id=d673788c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d673788c"]])

export default __exports__